import {combineReducers} from 'redux'
import {all, fork} from 'redux-saga/effects'
import {
  actions as snackbarActions,
  reducer as snackbarReducer,
  saga as snackbarSaga,
  State as SnackbarState,
} from './snackbar'

export interface IState {
  snackbar: SnackbarState
}

export const reducer = combineReducers<IState>({
  snackbar: snackbarReducer,
})

export function* saga(): any {
  yield all([
    fork(snackbarSaga),
  ])
}

export const actions = {
  ...snackbarActions,
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/main/index.ts